import "./org-header.ui.scss";
import logoNuclias from "../../assets/img/v2/icon/logo_nuclias_cloud.png";
import iconUser from "../../assets/img/v2/icon/icon_user.png";
import iconLanguage from "../../assets/img/v2/icon/icon_language_normal.png";

import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import useLangHook from "hooks/useLang";

// Component
import Icon from "components/Icon";
import DropdownWithItem from "components/DropdownWithItem";
import InputWithIcon from "components/InputWithIcon";

import { isNil, size, truncate } from "lodash";

import headerService from "../Headers/service";
import { iconType, DEFAULT_TARGET_OBJ, userDropdownList, truncConfig } from "../Headers/const";
import { userType } from "const/nuclias/user";

import { uiActions } from "stores/slice/ui";

const OrgHeader = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { langList, selectedLang, changeLang } = useLangHook();
  const { pageContext, user } = useSelector(store => store);
  const userDetail = {
    title: user?.user?.name,
    icon: user?.user?.profilePhotoS3Path || iconUser,
    userType: user?.user?.type
  };
  const [search, setSearch] = useState({ org: '', site: '' });
  const [options, setOptions] = useState({ tag: [], site: [] });
  const [targetObj, setTargetObj] = useState({
    org: DEFAULT_TARGET_OBJ,
    site: DEFAULT_TARGET_OBJ
  });

  const userDropdownClick = (item) => {
    if (item?.link) {
      navigate(item.link);
    } else if (item?.logout) {
      props.logout();
    }
  };

  const initOptions = () => {
    setOptions(options => ({ ...options, tag: headerService.initTagOption() }));
    setOptions(options => ({ ...options, site: headerService.initSiteOption() }));
  };

  const initTarget = () => {
    setTargetObj(targetObj => ({ ...targetObj, org: headerService.initTargetOrg() }));
    setTargetObj(targetObj => ({ ...targetObj, site: headerService.setTargetSite() }));
  };

  const initSearchSite = (target) => {
    if (size(target.value) !== 0) {
      target.value = '';
      setSearch((search) => ({
        ...search,
        site: '',
      }));
    }
  };

  const changeSite = (item) => { // async
    // dispatch(uiActions.showSpinner());
    headerService.changeSite(item);
    setTargetObj(targetObj => ({ ...targetObj, site: headerService.setTargetSite() }));
    // dispatch(uiActions.hideSpinner());
  };

  const siteList = () => {
    let updatedList = options.site.filter((item) => {
      return item.name.toLowerCase().indexOf(search.site.toLowerCase()) !== -1;
    });
    let data = updatedList.map((item, index) => {
      return (
        <li key={`org_header_site_dropdown_${index}`} className='search-site-item' onClick={() => { changeSite(item); }}>
          <i className={iconType.site}></i>{item.name}
        </li>
      );
    });
    if (size(data) > 0) {
      data.splice(0, 0, <hr key={`org_header_site_dropdown_hr`} />);
    }
    return data;
  };

  const tagList = () => {
    let updatedList = options.tag.filter((item) => {
      return item.name.toLowerCase().indexOf(search.site.toLowerCase()) !== -1;
    });
    let data = updatedList.map((item, index) => {
      return (
        <li key={index} className='search-tag-item' onClick={(e) => { changeSite(item); e.stopPropagation(); }}>
          <i className={iconType.tag}></i>{item.name}
        </li>
      );
    });
    return data;
  };

  useEffect(() => {
    initOptions();
    initTarget();
  }, [pageContext]);

  return (
    <>
      <header className="menu-container menu-container--org layout-container">
        <div className="left">
          <div className="icon icon-logo">
            <Link to="/dashboard" ><img src={logoNuclias} alt="Nuclias" /></Link>
          </div>
          <div className="org-dropdown">
            <div className="dropdown">
              <button
                className="btn btn-dropdown dropdown-toggle"
                type="button"
                id="orgDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                disabled
              >
                <span>
                  <i className={targetObj?.org.icon}></i>{truncate(targetObj?.org.name, truncConfig)}
                </span>
              </button>
            </div>
          </div>
          <div className="site-dropdown">
            <div className="dropdown">
              <button
                className="btn btn-dropdown dropdown-toggle"
                type="button"
                id="siteDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                disabled={!props?.headerDp?.enableSiteDp}
              >
                <span>
                  <i className={targetObj?.site.icon}></i>{truncate(t(targetObj?.site.name), truncConfig)}
                </span>
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="siteDropdown"
              >
                <InputWithIcon
                  type="text"
                  iconPosition="left"
                  iconClassName="icon-search"
                  onChange={(e) => { setSearch(search => ({ ...search, site: e.target.value })); }}
                  onFocus={() => { }}
                  onBlur={() => { }}
                  value={search.site}
                  onClick={(e) => initSearchSite(e.target)}
                />
                {
                  userDetail?.userType === userType.org &&
                  <li className='search-all-tag-item' onClick={() => { changeSite(null); }}>{t("b1c94ca2fb")}</li>
                }
                {tagList()}
                {siteList()}
              </ul>
            </div>
          </div>
        </div>
        <div className="right">
          {
            props.alerts.announcement.show &&
            <>
              <div className="item">
                <Icon className="icon-announcement" />
                <span
                  className="number"
                  style={{ visibility: props.alerts?.announcement.unread ? "visible" : "hidden" }}>
                  !
                </span>
              </div>
              <div className="divided"></div>
            </>
          }
          {
            props.alerts.alert.show &&
            <>
              <div className="item">
                <Icon className="icon-alerts" />
                <span className="number" style={{ visibility: props.alerts?.alert?.unread ? "visible" : "hidden" }}>!</span>
              </div>
              <div className="divided"></div>
            </>
          }

          <div className="item">
            <div className="dropdown">
              <img
                src={userDetail.icon}
                className="icon btn-dropdown user"
                id="langDropdown"
                data-bs-toggle="dropdown"
                alt=""
              />
              <DropdownWithItem
                id="user-dropdown"
                extendClassName="btn-dropdown-no-border"
                selectedItem={userDetail}
                itemList={userDropdownList()}
                onClick={userDropdownClick}
              />
            </div>
          </div>
          <div className="divided"></div>
          <div className="item">
            <div className="dropdown normal">
              <img
                src={iconLanguage}
                className="icon btn-dropdown"
                id="langDropdown"
                data-bs-toggle="dropdown"
                alt={selectedLang[0].title}
              />
              <DropdownWithItem
                id="lang-dropdown"
                extendClassName="btn-dropdown-no-border"
                selectedItem={selectedLang[0]}
                itemList={langList}
                onClick={(item) => changeLang(item)}
              />
            </div>
            <div className="dropdown rwd">
              <DropdownWithItem
                id="lang-dropdown"
                type="icon"
                extendClassName="icon-language"
                selectedItem={selectedLang[0]}
                itemList={langList}
                onClick={(item) => changeLang(item)}
              />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default OrgHeader;